import { render } from "./NumberChoiceStep.vue?vue&type=template&id=189af316"
import script from "./NumberChoiceStep.vue?vue&type=script&lang=ts"
export * from "./NumberChoiceStep.vue?vue&type=script&lang=ts"
script.render = render

export default script